import React from 'react';

import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

export const HeaderText = styled(StyledTypography)`
  font-size: ${(props) => props.theme.typography.body1.fontSize};
`;

export const SmallHeaderText = styled(StyledTypography)`
  font-size: 0.75rem;
`;

export function NumberFormatCustom(props) {
  const { inputRef, onChange, groupStyle = 'lakh', ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      thousandsGroupStyle={groupStyle}
    />
  );
}

export const IndianNumberFormatCustom = (props) => <NumberFormatCustom groupStyle="lakh" {...props} />;

export const ForeignNumberFormatCustom = (props) => <NumberFormatCustom groupStyle="thousand" {...props} />;
